<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <!-- 第一屏 -->
      <swiper-slide class="swiper-slide slide-one">
        <div class="page">
          <h3>Professional Supplier of</h3>
          <p>Electronic Components</p>
        </div>
      </swiper-slide>

      <!-- 第二屏 -->
      <swiper-slide class="swiper-slide slide-two">
        <div class="page">
          <h3>Hot Products</h3>
        </div>
        <ul class="case-item">
          <li
            v-for="(item, index) in caseList"
            :key="index"
            :style="{ backgroundImage: `url(${item.Img})` }"
            class="image-item"
          >
            <!-- 可选 hover 内容 -->
            <div class="case-item-hover">
              <div class="hover-title">{{ item.title }}</div>
              <div class="bottom"></div>
              <div class="more"><span>More</span></div>
            </div>
          </li>
        </ul>
      </swiper-slide>

      <!-- 第三屏 -->
      <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <h3>About Us</h3>
        </div>
        <div class="news-content">
          <h2>
            Genuine Mall(HK) Electronics Limited is a world-famous franchise semiconductor integrated circuit (IC), patch the transistor, capacitor, the regulator, inductors, tantalum capacitors, FET, a two-way single SCR, of rlington, 3 End of the regulator, Optocoupler large suppliers. The company has many years of sales management experience, professional supporting a variety of electronic components, with a large number of long-term cash inventory.
          </h2>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      loading: false,
      // 本地图片列表
      caseList: [
        { Img: '/img1/case1.jpg', title: 'Case 1' },
        { Img: '/img1/case2.jpg', title: 'Case 2' },
        { Img: '/img1/case3.jpg', title: 'Case 3' },
        { Img: '/img1/case4.jpg', title: 'Case 4' },
        { Img: '/img1/case5.jpg', title: 'Case 5' },
        { Img: '/img1/case6.jpg', title: 'Case 6' },
      ],
      swiperOption: {
        notNextTick: true,
        direction: "vertical",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        slidesPerView: 1,
        mousewheel: true,
        mousewheelControl: true,
        height: window.innerHeight - 60,
        resistanceRatio: 0,
        observeParents: true,
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-slide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 24px;

  .page {
    height:100px;
    text-align: center;
    overflow: hidden;

    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }
}

.case-item {
  width: 1100px;
  height: 400px;
  margin: 30px auto 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  li {
    width: 330px;
    height: 250px;
    margin: 5px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }

    .case-item-hover {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      background-color: rgba(225, 56, 52, 0.7);
      transition: opacity 0.4s ease-in-out;

      &:hover {
        opacity: 1;
      }

      .hover-title {
        height: 50px;
        color: #fff;
        font-size: 18px;
        margin-top: 20px;
      }

      .bottom {
        border-bottom: 1px solid #fff;
        width: 60px;
        margin: 0 auto;
      }

      .more {
        width: 90px;
        padding: 5px;
        margin: 0 auto;
        margin-top: 100px;
        border: 2px solid #fff;
        text-align: center;

        span {
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }
}

.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}

.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}

.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}

.news-content {
  width: 1240px;
  margin: 40px auto 0;
  display: flex;
  justify-content: center;

  h2 {
    color: #fff;
    line-height: 1.5;
    text-align: justify;
  }
}
</style>
